import React, { FunctionComponent } from 'react';
import GenericAccordion from '../../../../../gqlCommon/components/presentation/genericAccordion/GenericAccordion';
import { useExpandSections } from '../../../../hooks/navigation/useExpandSections';
import FeatureSectionDetailsContainer from './featureSectionDetails/FeatureSectionDetailsContainer';
import ISection from '../../../../model/ISection';
import variantSelectorBaseStyles from '../variantsSection/variantSelectorBase/variantSelectorStyles';
import FeatureSectionTitleContainer from './FeatureSectionTitleContainer';
import useSalesEnablementContext from '../../../../../gqlCommon/hooks/useSalesEnablementContext';
import { sectionHasVisibleFeatures } from '../../../../utils/sectionHasVisibleFeatures';
export interface IFeatureSectionProps {
  section: ISection;
  loading: boolean;
}

const FeatureSection: FunctionComponent<IFeatureSectionProps> = ({ section, loading }) => {
  const { setExpandedSection, currentSection } = useExpandSections(section.code);
  const { isInSalesEnablement } = useSalesEnablementContext();
  const hasAvailableCategories = sectionHasVisibleFeatures(section.categories, isInSalesEnablement);
  const styles = variantSelectorBaseStyles();

  if (section?.featuresList?.features.length === 0 && !hasAvailableCategories) {
    return null;
  }

  return (
    <GenericAccordion
      expanded={currentSection}
      setExpanded={setExpandedSection}
      classes={{ accordionSummary: styles.accordionSummary }}
      defaultExpanded={true}
      dataTest={`container:section:${section.code}`}
      summary={
        <FeatureSectionTitleContainer
          sectionCode={section.code}
          label={section.label}
          disclaimerIndicative={section.attributes?.disclaimerindicative}
        />
      }
      details={<FeatureSectionDetailsContainer section={section} loading={loading} />}
    />
  );
};

export default FeatureSection;
